import { render, staticRenderFns } from "./Game4-10.vue?vue&type=template&id=1e647a15&scoped=true&"
import script from "./Game4-10.vue?vue&type=script&lang=js&"
export * from "./Game4-10.vue?vue&type=script&lang=js&"
import style0 from "./Game4-10.vue?vue&type=style&index=0&id=1e647a15&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e647a15",
  null
  
)

export default component.exports